<template>
<div style="width:98%" class="p-4">
  <div class="flex space-x-4 mb-4 border-b">
    <button
      :class="{'border-b-2 border-blue-500 font-semibold': activeTab === 'stt'}"
      @click="activeTab = 'stt'"
      class="px-4 py-2"
    >
      STT Providers
    </button>
    <button
      :class="{'border-b-2 border-blue-500 font-semibold': activeTab === 'llm'}"
      @click="activeTab = 'llm'"
      class="px-4 py-2"
    >
      LLM Providers
    </button>
  </div>
  <div v-show="activeTab === 'stt'">
    <div class="flex items-center justify-between mb-4">
     
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
       STT Providers Configuration
      </h1>
      <div class="text-gray-700 bg-gray-200 px-3 py-2 rounded flex items-center space-x-4">
        <div class="flex items-center space-x-1 text-yellow-900">
          <Icon icon="oui:token-alias" />
          <span>TPM: {{ totalTPM }}</span>
        </div>
        <div class="flex items-center space-x-1 text-blue-900">
          <Icon icon="mynaui:api-solid"/>
          <span>RPM: {{ totalRPM }}</span>
        </div>
        <div class="flex items-center text-green-900">
          <svg fill="none" stroke="currentColor" class="h-5 w-5 mr-3" viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M1,16V8A1,1,0,0,1,3,8v8a1,1,0,0,1-2,0Zm7,4V4A1,1,0,0,0,6,4V20a1,1,0,0,0,2,0Zm5,2V2a1,1,0,0,0-2,0V22a1,1,0,0,0,2,0Zm5-2V4a1,1,0,0,0-2,0V20a1,1,0,0,0,2,0ZM22,7a1,1,0,0,0-1,1v8a1,1,0,0,0,2,0V8A1,1,0,0,0,22,7Z">
                  </path>
                </svg>
          <span>Conversations/min: {{ conversationsPerMinute }}</span>
        </div>
      </div>
    </div>
    <div class="mb-4 flex items-center space-x-2">
      <select v-model="selectedProvider" class="border p-2 rounded">
        <option disabled value="">Select a provider to add</option>
        <option v-for="(p, idx) in knownProviders" :key="idx" :value="p">{{ p.name }}</option>
      </select>
      <button @click="addProvider"
        class="btn" style="background-color:#e9e9e9;">
        Add Provider
      </button>
    </div>
    <draggable v-model="providers" item-key="id" :animation="200" handle=".handle">
      <template #item="{ element }">
        <div class="p-4 mb-2 bg-white shadow rounded border border-gray-200">
          <div class="flex items-center" @click="element.isCollapsed = !element.isCollapsed" style="cursor: pointer;">
            <div class="handle mr-3 text-gray-400 cursor-move inline-flex" @click.stop>
              <icon icon="tabler:grip-vertical" width="28px"/>
            </div>
            <div class="text-lg font-semibold flex items-center">
              <Icon v-if="element.name.includes('Azure')!=false" width="28px" icon="devicon:azure" class="mr-2"/>
              <Icon v-if="element.name.includes('Open AI')!=false" width="28px" icon="logos:openai-icon" class="mr-2"/>
              <svg v-if="element.name.includes('sonarix')!=false"  xmlns="http://www.w3.org/2000/svg" class="h-9 w-9 text-indigo-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>
              {{ element.name }}
            </div>
            <div class="ml-auto flex items-center space-x-2" style="pointer-events: none;">
              <span v-if="element.fields.tpm !== undefined && element.fields.tpm !== null && element.fields.tpm !== ''" class="inline-flex items-center bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                TPM: {{ element.fields.tpm }}
              </span>
              <span v-if="element.fields.rpm !== undefined && element.fields.rpm !== null && element.fields.rpm !== ''" class="inline-flex items-center bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                RPM: {{ element.fields.rpm }}
              </span>
              <svg v-if="!(element.isCollapsed === true)" class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" stroke-width="2"
                   viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7"></path>
              </svg>
              <svg v-else class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" stroke-width="2"
                   viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
          </div>
          <div class="mt-3 ml-9" v-show="!(element.isCollapsed === true)">
            <div v-if="element.name === 'sonarixSTT v1.0'">
              <label class="block mb-2">
                <span class="text-gray-700">STT URL Service</span>
                <input v-model="element.fields.sttUrlService" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">JWT Token</span>
                <input v-model="element.fields.jwtToken" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">TPM</span>
                <input type="number" v-model="element.fields.tpm" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">RPM</span>
                <input type="number" v-model="element.fields.rpm" class="border rounded w-full p-2" @click.stop />
              </label>
            </div>
            <div v-else-if="element.name === 'Azure Open AI Whisper'">
              <label class="block mb-2">
                <span class="text-gray-700">Endpoint</span>
                <input v-model="element.fields.endpoint" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">Token</span>
                <input v-model="element.fields.token" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">Model</span>
                <select v-model="element.fields.model" class="border rounded w-full p-2" @click.stop>
                  <option value="">Select a model</option>
                  <option value="Whisper-large">Whisper-large</option>
                  <option value="whisper-large-v3">whisper-large-v3</option>
                  <option value="whisper-large-v3-turbo">whisper-large-v3-turbo</option>
                </select>
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">TPM</span>
                <input type="number" v-model="element.fields.tpm" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">RPM</span>
                <input type="number" v-model="element.fields.rpm" class="border rounded w-full p-2" @click.stop />
              </label>
            </div>
            <div v-else-if="element.name === 'Azure Speech Service (Batch API)'">
              <label class="block mb-2">
                <span class="text-gray-700">Endpoint</span>
                <input v-model="element.fields.endpoint" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">Subscription key</span>
                <input v-model="element.fields.subscriptionKey" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">Region</span>
                <input v-model="element.fields.region" class="border rounded w-full p-2" @click.stop />
              </label>
              <div class="border rounded p-2 bg-gray-50 mb-2">
                <h3 class="font-semibold mb-2">Blob Storage Settings</h3>
                <label class="block mb-2">
                  <span class="text-gray-700">Connection String</span>
                  <input v-model="element.fields.blobConnectionString" class="border rounded w-full p-2" @click.stop />
                </label>
                <label class="block mb-2">
                  <span class="text-gray-700">Container Name</span>
                  <input v-model="element.fields.blobContainerName" class="border rounded w-full p-2" @click.stop />
                </label>
              </div>
              <label class="block mb-2">
                <span class="text-gray-700">TPM</span>
                <input type="number" v-model="element.fields.tpm" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">RPM</span>
                <input type="number" v-model="element.fields.rpm" class="border rounded w-full p-2" @click.stop />
              </label>
            </div>
            <div class="flex flex-row-reverse">
              <button class="btn btn-error float-right" @click="deleteSTTProvider(element.id)">Delete</button>
  
              </div>
          </div>
        </div>
      </template>
    </draggable>
    <div v-if="providers.length<=0" class="card font-bold text-center">
      No Providers are found.
    </div>
    <div class="flex flex-row-reverse">
              <button class="btn float-right">Apply Changes</button>
  
              </div>
    <div class="mt-8 p-4 bg-white shadow rounded border border-gray-200 hidden">
      <h2 class="text-xl font-bold mb-2">Import / Export Configuration</h2>
      <div class="flex flex-col sm:flex-row sm:space-x-4">
        <div class="flex-1 mb-4 sm:mb-0">
          <label class="block mb-2 font-semibold">Imported JSON</label>
          <textarea v-model="importJson"
                    class="w-full border rounded p-2"
                    rows="6"
                    placeholder="Paste your JSON here to import.">
          </textarea>
          <button @click="handleImport"
                  class="mt-2 bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700 transition">
            Import
          </button>
        </div>
        <div class="flex-1">
          <label class="block mb-2 font-semibold">Exported JSON</label>
          <textarea :value="exportedJson"
                    readonly
                    class="w-full border rounded p-2 bg-gray-100"
                    rows="6">
          </textarea>
          <button @click="handleExport"
                  class="mt-2 bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition">
            Export
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-show="activeTab === 'llm'">
    <div class="flex items-center justify-between mb-4">
      <div>
      <h1 class="text-2xl text-gray-900 dark:text-gray-200 font-medium">
       LLM Providers Configuration
      </h1>
      
      
    </div>
      <div class="text-gray-700 bg-gray-200 px-3 py-2 rounded flex items-center space-x-4">
        <div class="flex items-center space-x-1 text-green-900">
          <Icon icon="oui:token-alias" />
         
          <span>TPM: {{ totalLLMTPM }}</span>
        </div>
        <div class="flex items-center space-x-1 text-blue-900">
          
          <Icon icon="mynaui:api-solid"/>
         
          <span>RPM: {{ totalLLMRPM }}</span>
        </div>
      </div>
    </div>
    <div class="mb-4 flex items-center space-x-2">
      <select v-model="selectedLLMProvider" class="border p-2 rounded">
        <option disabled value="">Select a provider to add</option>
        <option v-for="(p, idx) in knownLLMProviders" :key="idx" :value="p">{{ p.name }}</option>
      </select>
      <button @click="addLLMProvider" style="background-color:#e9e9e9;"
        class="btn">
        Add Provider
      </button>
    </div>
    <draggable v-model="llmProviders" item-key="id" :animation="200" handle=".llm-handle">
      <template #item="{ element }">
        <div class="p-4 mb-2 bg-white shadow rounded border border-gray-200">
          <div class="flex items-center" @click="element.isCollapsed = !element.isCollapsed" style="cursor: pointer;">
            <div class="llm-handle mr-3 text-gray-400 cursor-move inline-flex" @click.stop>
              <icon icon="tabler:grip-vertical" width="28px"/>
            </div>
            <div class="text-lg font-semibold flex items-center">
              <Icon v-if="element.name.includes('Azure')!=false" width="28px" icon="devicon:azure" class="mr-2"/>
              <Icon v-if="element.name.includes('Open AI')!=false" width="28px" icon="logos:openai-icon" class="mr-2"/>
              <Icon v-if="element.name.includes('Google')!=false" width="28px" icon="devicon:google" class="mr-2"/>
              <svg v-if="element.name.includes('sonarix')!=false"  xmlns="http://www.w3.org/2000/svg" class="h-9 w-9 text-indigo-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"></path></svg>
              {{ element.name }}
            </div>
            <div class="ml-auto flex items-center space-x-2" style="pointer-events: none;">
              <span v-if="element.fields.tpm !== undefined && element.fields.tpm !== null && element.fields.tpm !== ''" class="inline-flex items-center bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                TPM: {{ element.fields.tpm }}
              </span>
              <span v-if="element.fields.rpm !== undefined && element.fields.rpm !== null && element.fields.rpm !== ''" class="inline-flex items-center bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full">
                RPM: {{ element.fields.rpm }}
              </span>
              <svg v-if="!(element.isCollapsed === true)" class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" stroke-width="2"
                   viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" d="M5 15l7-7 7 7"></path>
              </svg>
              <svg v-else class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" stroke-width="2"
                   viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
          </div>
          <div class="mt-3 ml-9" v-show="!(element.isCollapsed === true)">
            <div v-if="['Azure Open AI GPT 4o','Azure Open AI o1'].includes(element.name)">
              <label class="block mb-2">
                <span class="text-gray-700">Endpoint</span>
                <input v-model="element.fields.endpoint" class="border rounded w-full p-2" @click.stop/>
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">Token</span>
                <input v-model="element.fields.token" class="border rounded w-full p-2" @click.stop/>
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">TPM</span>
                <input type="number" v-model="element.fields.tpm" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">RPM</span>
                <input type="number" v-model="element.fields.rpm" class="border rounded w-full p-2" @click.stop />
              </label>
            </div>
            <div v-else-if="[
              'Google Gemini 1.5 Flash 002',
              'Google Gemini 1.5 Pro 002',
              'Google Gemini 2.0 Flash',
              'Google Gemini 2.0 Flash Thinking',
              'Google Gemini 2.0 Pro'
            ].includes(element.name)">
              <label class="block mb-2">
                <span class="text-gray-700">Key</span>
                <input v-model="element.fields.key" class="border rounded w-full p-2" @click.stop/>
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">TPM</span>
                <input type="number" v-model="element.fields.tpm" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">RPM</span>
                <input type="number" v-model="element.fields.rpm" class="border rounded w-full p-2" @click.stop />
              </label>
            </div>
            <div v-else-if="element.name === 'sonarixLM v1.0'">
              <label class="block mb-2">
                <span class="text-gray-700">LM URL Service</span>
                <input v-model="element.fields.lmUrlService" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">JWT Token</span>
                <input v-model="element.fields.jwtToken" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">TPM</span>
                <input type="number" v-model="element.fields.tpm" class="border rounded w-full p-2" @click.stop />
              </label>
              <label class="block mb-2">
                <span class="text-gray-700">RPM</span>
                <input type="number" v-model="element.fields.rpm" class="border rounded w-full p-2" @click.stop />
              </label>
            </div>
            <div class="flex flex-row-reverse">
              <button class="btn btn-error float-right" @click=deleteLLMProvider(element.id)>Delete</button>
  
              </div>
          </div>
        </div>
      </template>
    </draggable>
    <div v-if="llmProviders.length<=0" class="card font-bold text-center">
      No Providers are found.
    </div>
    <div class="flex flex-row-reverse">
              <button class="btn float-right">Apply Changes</button>
  
              </div>
    <div class="mt-8 p-4 bg-white shadow rounded border border-gray-200 hidden">
      <h2 class="text-xl font-bold mb-2">Import / Export LLM Configuration</h2>
      <div class="flex flex-col sm:flex-row sm:space-x-4">
        <div class="flex-1 mb-4 sm:mb-0">
          <label class="block mb-2 font-semibold">Imported JSON</label>
          <textarea v-model="importLLMJson"
                    class="w-full border rounded p-2"
                    rows="6"
                    placeholder="Paste your JSON here to import.">
          </textarea>
          <button @click="handleLLMImport"
                  class="mt-2 bg-green-600 text-white px-3 py-2 rounded hover:bg-green-700 transition">
            Import
          </button>
        </div>
        <div class="flex-1">
          <label class="block mb-2 font-semibold">Exported JSON</label>
          <textarea :value="exportedLLMJson"
                    readonly
                    class="w-full border rounded p-2 bg-gray-100"
                    rows="6">
          </textarea>
          <button @click="handleLLMExport"
                  class="mt-2 bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition">
            Export
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>






</template>
<style src="@vueform/multiselect/themes/default.css"></style>
<style>
table {
  font-family: "Heebo", sans-serif !important;
}
</style>
<script setup>
import { ref, onMounted, computed,defineComponent } from 'vue';
import draggable from 'vuedraggable'
import { Icon } from "@iconify/vue/dist/offline";

const activeTab = ref('stt');
    const knownProviders = [
      {
        providerId: "sonarixSTT_v1",
        name: "sonarixSTT v1.0",
        fields: { sttUrlService: "", jwtToken: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "azureOpenAIWhisper",
        name: "Azure Open AI Whisper",
        fields: { endpoint: "", token: "", model: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "azureSpeechBatchAPI",
        name: "Azure Speech Service (Batch API)",
        fields: { endpoint: "", subscriptionKey: "", region: "", blobConnectionString: "", blobContainerName: "", tpm: "", rpm: "" },
        isCollapsed: false
      }
    ];
    const providers = ref([]);
    const selectedProvider = ref("");
    const importJson = ref("");
    const exportedJson = ref("");
    const totalTPM = computed(() => {
      return providers.value.reduce((sum, provider) => {
        const val = parseInt(provider.fields.tpm != undefined ? provider.fields.tpm : 0);
        return sum + val;
      }, 0);
    });
    const totalRPM = computed(() => {
      return providers.value.reduce((sum, provider) => {
        const val = parseInt(provider.fields.rpm != undefined ? provider.fields.rpm : 0);
        return sum + val;
      }, 0);
    });
    const conversationsPerMinute = computed(() => {
      return totalRPM.value;
    });
    function generateId() {
      return '_' + Math.random().toString(36).substr(2, 9);
    }
    function addProvider() {
      if (selectedProvider.value.length<=0) {
        return;
      }
      const newProvider = JSON.parse(JSON.stringify(selectedProvider.value));
      newProvider.id = generateId();
      if (newProvider.fields  === undefined) {
        newProvider.fields = {};
      }
      if (newProvider.isCollapsed === undefined) {
        newProvider.isCollapsed = false;
      }
      providers.value.push(newProvider);
      selectedProvider.value = "";
    }
    function handleImport() {
      const importedData = JSON.parse(importJson.value);
      if (Array.isArray(importedData)!=false) {
        providers.value = importedData.map(item => {
          if (item.isCollapsed === undefined) {
            item.isCollapsed = false;
          }
          return item;
        });
      } else {
        alert("Imported data is not a valid array.");
      }
    }
    function handleExport() {
      exportedJson.value = JSON.stringify(providers.value, null, 2);
    }
    const knownLLMProviders = [
      {
        providerId: "azureOpenAIGPT4o",
        name: "Azure Open AI GPT 4o",
        fields: { endpoint: "", token: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "azureOpenAIo1",
        name: "Azure Open AI o1",
        fields: { endpoint: "", token: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "googleGemini15Flash002",
        name: "Google Gemini 1.5 Flash 002",
        fields: { key: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "googleGemini15Pro002",
        name: "Google Gemini 1.5 Pro 002",
        fields: { key: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "googleGemini20Flash",
        name: "Google Gemini 2.0 Flash",
        fields: { key: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "googleGemini20FlashThinking",
        name: "Google Gemini 2.0 Flash Thinking",
        fields: { key: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "googleGemini20Pro",
        name: "Google Gemini 2.0 Pro",
        fields: { key: "", tpm: "", rpm: "" },
        isCollapsed: false
      },
      {
        providerId: "sonarixLMv1",
        name: "sonarixLM v1.0",
        fields: { lmUrlService: "", jwtToken: "", tpm: "", rpm: "" },
        isCollapsed: false
      }
    ];
    const llmProviders = ref([]);
    const selectedLLMProvider = ref("");
    const importLLMJson = ref("");
    const exportedLLMJson = ref("");
    const totalLLMTPM = computed(() => {
      return llmProviders.value.reduce((sum, provider) => {
        const val = parseInt(provider.fields.tpm != undefined ? provider.fields.tpm : 0);
        return sum + val;
      }, 0);
    });
    const totalLLMRPM = computed(() => {
      return llmProviders.value.reduce((sum, provider) => {
        const val = parseInt(provider.fields.rpm != undefined ? provider.fields.rpm : 0);
        return sum + val;
      }, 0);
    });
    function deleteSTTProvider(id){
      console.log(id);
      providers.value=providers.value.filter(item => item.id !== id);
    }
    function deleteLLMProvider(id){
      llmProviders.value=llmProviders.value.filter(item => item.id !== id);
    }
    function addLLMProvider() {
      if (selectedLLMProvider.value.length<=0) return;
      const newProvider = JSON.parse(JSON.stringify(selectedLLMProvider.value));
      newProvider.id = generateId();
      if (newProvider.fields  === undefined) {
        newProvider.fields = {};
      }
      if (newProvider.isCollapsed === undefined) {
        newProvider.isCollapsed = false;
      }
      llmProviders.value.push(newProvider);
      selectedLLMProvider.value = "";
    }
    function handleLLMImport() {
      const importedData = JSON.parse(importLLMJson.value);
      if (Array.isArray(importedData)!=false) {
        llmProviders.value = importedData.map(item => {
          if (item.isCollapsed === undefined) {
            item.isCollapsed = false;
          }
          return item;
        });
      } else {
        alert("Imported data is not a valid array.");
      }
    }
    function handleLLMExport() {
      exportedLLMJson.value = JSON.stringify(llmProviders.value, null, 2);
    }

</script>
